import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {MONTH_VARIANTS} from '@/constants';
import {MonthDateValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateMonthDate = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
): string | null => {
  if (!ValidationUtils.isValidationRule<MonthDateValidationRule>(rule, StatisticItemValidationType.MonthDate)) {
    return null;
  }

  let statisticValue = statistic.value;
  const ruleValue = rule.value;
  const date = new Date(statisticValue);
  const month = date.getMonth();
  const year = date.getFullYear();

  if (
    Number.isNaN(month) ||
    Number.isNaN(year) ||
    !ValidationUtils.isStringValue(statisticValue) ||
    !ValidationUtils.isCurrentYearValue(year)
  ) {
    // логируем невалидное значение даты
    const error = FrontendError.createNotDateValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (ruleValue && MONTH_VARIANTS[month]) {
    statisticValue = MONTH_VARIANTS[month][0];
  }

  return statisticValue;
};
